import { Component } from '@angular/core';

@Component({
  selector: 'app-readings',
  templateUrl: './readings.component.html',
  styleUrl: './readings.component.scss',
  standalone: false
})
export class ReadingsComponent {

}
